import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import BreadcrumbSchema from '@/components/BreadcrumbSchema';

// Renders a subtle, visible breadcrumb trail AND its matching BreadcrumbList
// schema together, so the structured data always matches what's on screen.
// items: [{ name, path }] — the last item is treated as the current page.
const SeoBreadcrumbs = ({ items }) => (
  <>
    <BreadcrumbSchema items={items} />
    <nav className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-6" aria-label="Breadcrumb" data-testid="seo-breadcrumbs">
      <Breadcrumb>
        <BreadcrumbList className="text-xs">
          {items.map((item, i) => (
            <React.Fragment key={item.path}>
              {i > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {i === items.length - 1 ? (
                  <BreadcrumbPage>{item.name}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={item.path}>{item.name}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </nav>
  </>
);

export default SeoBreadcrumbs;
